// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"44438284","258":"9c490ddf","453":"3fc5522e","609":"462578a5","648":"3872ee1d","684":"4958d5f1"}[chunkId] + ".chunk.js";
};